export default function URL($window) {
    'ngInject';

    return {
        createObjectURL: (...args) => $window.URL.createObjectURL.apply($window.URL, args),
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/common/wrappers/URL.js